export default __webpack_public_path__ + "static/media/total.efc003fe.svg";